import React, { Component } from "react";


export default class SliderMarker extends Component {
	static defaultProp = {
		className: "",
		style: {},
		value: 0,
		onLayout: _ => {},
		onMouseDown: _ => {},
		onMouseUp: _ => {}
	};

	render() {
		const { className, onLayout, ...props } = this.props;

		return (
			<div className={"slider-marker-container " + (className ? className : "")} ref={onLayout} {...props}>
				<div className="slider-marker-pin" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Slider/marker.js